import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, switchMap } from "rxjs/operators";

import { AnnouncementsApiActions } from "../actions/data/action-creators/announcements-api.action";
import { AnnouncementsModel } from "../../../shared/models/announcements.model";
import { Announcement } from "../reducers/data/announcements.reducer";
import { AnnouncementsActions } from "../actions/data/action-creators/announcements.action";
import { AWSCommand } from "../../../shared/commands";

@Injectable()
export class AnnouncementsEffects {
	private actions$ = inject(Actions);
	private announcementsModel = inject(AnnouncementsModel);

	getAnnouncements$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(AnnouncementsActions.getAnnouncements),
			switchMap(() =>
				this.announcementsModel.performAction(AnnouncementsApiActions.getAnnouncements()).pipe(
					// @ts-expect-error TS2345
					map((response: { payload: Announcement[]; command: AWSCommand }) => response.payload),
					map((response: Announcement[]) => {
						return AnnouncementsApiActions.getAnnouncementsSuccess({ announcements: response });
					}),
				),
			),
		);
	});

	setAnnouncementAcknowledged$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(AnnouncementsActions.setAnnouncementAcknowledged),
			switchMap(({ version }) => {
				return this.announcementsModel
					.performAction(AnnouncementsApiActions.updateAnnouncementsAcknowledge({ payload: { version } }))
					.pipe(
						map((response) => response.payload),
						map(() => {
							return AnnouncementsApiActions.updateAnnouncementsAcknowledgedSuccess({ version });
						}),
					);
			}),
		);
	});

	setAnnouncementRead$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(AnnouncementsActions.setAnnouncementRead),
			switchMap(({ version }) => {
				return this.announcementsModel
					.performAction(AnnouncementsApiActions.updateAnnouncementsRead({ payload: { version } }))
					.pipe(
						map((response) => response.payload),
						map(() => {
							return AnnouncementsApiActions.updateAnnouncementsReadSuccess({ version });
						}),
					);
			}),
		);
	});
}
